
import React from 'react';
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Mail, Copy, ExternalLink } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import KnowledgeBase from './KnowledgeBase';
import { useIsMobile } from '@/hooks/use-mobile';

const EMAIL_ADDRESS = "hello@mindnote.online";

const SupportDialog = () => {
  const { toast } = useToast();
  const isMobile = useIsMobile();
  
  const handleCopyEmail = () => {
    navigator.clipboard.writeText(EMAIL_ADDRESS);
    toast({
      title: "Email copied",
      description: "Email address has been copied to your clipboard",
    });
  };
  
  const handleOpenEmail = () => {
    window.open(`mailto:${EMAIL_ADDRESS}`, '_blank');
  };

  return (
    <DialogContent className={`sm:max-w-lg max-h-[85vh] ${isMobile ? 'p-3 w-[95vw]' : 'p-6'}`}>
      <DialogHeader className={`${isMobile ? 'mb-2' : 'mb-4'}`}>
        <DialogTitle className="text-center">Support</DialogTitle>
      </DialogHeader>
      
      <Tabs defaultValue="contact" className="w-full">
        <TabsList className={`grid w-full grid-cols-2 mb-3 ${isMobile ? 'h-auto' : ''}`}>
          <TabsTrigger value="contact" className={`${isMobile ? 'text-xs px-2 py-2' : ''}`}>
            Contact Us
          </TabsTrigger>
          <TabsTrigger value="knowledge" className={`${isMobile ? 'text-xs px-2 py-2' : ''}`}>
            Knowledge Base
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="contact" className="space-y-3 py-2">
          <div className="flex flex-col items-center justify-center space-y-3 p-3 bg-accent/50 rounded-lg">
            <p className={`text-center text-foreground ${isMobile ? 'text-sm' : ''}`}>
              Need help? Contact our support team at:
            </p>
            <div className={`flex items-center gap-2 ${isMobile ? 'flex-wrap justify-center' : ''}`}>
              <Mail className={`${isMobile ? 'h-4 w-4' : 'h-5 w-5'} text-foreground`} />
              <span className={`font-medium text-foreground ${isMobile ? 'text-sm break-all' : ''}`}>
                {EMAIL_ADDRESS}
              </span>
            </div>
            <div className={`flex ${isMobile ? 'flex-col w-full' : 'flex-row'} gap-2 mt-2`}>
              <Button 
                variant="outline" 
                size={isMobile ? "default" : "sm"} 
                onClick={handleCopyEmail}
                className={isMobile ? 'w-full text-xs' : ''}
              >
                <Copy className="h-4 w-4 mr-2" />
                Copy Email
              </Button>
              <Button 
                onClick={handleOpenEmail}
                size={isMobile ? "default" : "sm"}
                className={isMobile ? 'w-full text-xs' : ''}
              >
                <ExternalLink className="h-4 w-4 mr-2" />
                Open Email Client
              </Button>
            </div>
          </div>
        </TabsContent>
        
        <TabsContent value="knowledge" className="max-h-[60vh] overflow-y-auto pr-1">
          <KnowledgeBase />
        </TabsContent>
      </Tabs>
    </DialogContent>
  );
};

export default SupportDialog;
